import { sessionStore } from 'utils/storage'
import { AIDA_COMPOSER_DRAFT_KEY } from '../utils/constants/storage-keys'

export function readAidaComposerDraft(): string {
  const stored = sessionStore.getString(AIDA_COMPOSER_DRAFT_KEY)
  return stored ?? ''
}

export function writeAidaComposerDraft(draft: string) {
  if (draft.length === 0) {
    sessionStore.remove(AIDA_COMPOSER_DRAFT_KEY)
    return
  }
  sessionStore.setString(AIDA_COMPOSER_DRAFT_KEY, draft)
}

export function clearAidaComposerDraft() {
  sessionStore.remove(AIDA_COMPOSER_DRAFT_KEY)
}
